export enum AccountStatus {
    None = 0,
    Active = 1,
    Inactive = 2,
    DNA = 3,
    Purge = 4
}
